import { useQuery } from '@tanstack/react-query'
import { api } from '@/api/client'

interface ActivityItem {
  id: string
  type: string
  summary: string
  detail?: string
  channel?: string
  timestamp: string
}

interface ActivityResponse {
  items: ActivityItem[]
  total: number
  has_more: boolean
}

export const activityKeys = {
  all: ['agent-activity'] as const,
  list: (limit: number) => ['agent-activity', 'list', limit] as const,
}

export function useAgentActivity(limit = 50) {
  return useQuery({
    queryKey: activityKeys.list(limit),
    queryFn: () => api.get<ActivityResponse>(`/api/v1/agent/activity?limit=${limit}`),
    refetchInterval: 30000, // Poll every 30 seconds
    staleTime: 10000,
  })
}

export type { ActivityItem, ActivityResponse }
